import { DropDownList } from '@progress/kendo-react-dropdowns';
import { FC } from 'react';
import { IS_MULTILINGUAL } from 'src/config';
import { LanguageCategories } from 'src/constants/localization';
import useLocaleContext from 'src/hooks/useLocaleContext';

interface SelectLanguageProps {}

const SelectLanguage: FC<SelectLanguageProps> = () => {
  const { selectedLanguage, handleLanguageChange, t } = useLocaleContext();

  if (!IS_MULTILINGUAL) {
    return <></>;
  }
  return (
    <div className="flex min-w-0 w-full shrink-0 flex-row flex-wrap items-center gap-2 sm:w-auto sm:flex-nowrap">
      <label
        className="min-w-0 break-words text-sm font-bold text-white sm:truncate sm:text-base"
        htmlFor="view-drop-down-list"
        title={t('Select a Language') + ':'}
      >
        {t('Select a Language') + ':'}
      </label>
      <div className="w-[100px] shrink-0">
        <DropDownList
          id="view-drop-down-list"
          style={{ width: '100%' }}
          data={LanguageCategories}
          textField="label"
          dataItemKey="value"
          value={selectedLanguage}
          onChange={handleLanguageChange}
        />
      </div>
    </div>
  );
};

export default SelectLanguage;
